import { create } from "zustand";

export interface AlertStoreType {
  show: boolean;
  message: string;
  type: string;
  title: string;
  setMessage: (show: boolean, message: string, type: string, title: string) => void;
  setShow: (show: boolean) => void;
}

export const useAlertStore = create<AlertStoreType>(
  (set) => ({
    show: false,
    message: '',
    type: 'info',
    title: '',
    setMessage: (show: boolean, message: string, type: string, title: string) => set({ show, message, type, title }),
    setShow: (show: boolean) => set({ show }),
  }),
);
